import React from "react";

import { ButtonWrapper } from "./style";
const Index = (props) => {
  const {
    variant,
    type,
    className,
    text,
    disabled,
    onClick,
    icon,
    startIcon,
    marginBottom,
    endIcon,
    flexColumn,
    minWidth,
    height,
    fontSize,
    innerButton,
    innerButtonText,
    fileUrl,
    innerButtonClick
  } = props

  return (
    <ButtonWrapper
      onClick={onClick}
      variant={variant}
      height={height}
      type={type}
      className={className}
      disabled={disabled}
      marginBottom={marginBottom}
      minWidth={minWidth}
      fontSize={fontSize}
    >
      <div className={`d-flex align-items-center justify-content-center gap-1 ${flexColumn ? 'flex-column' : ''}`}>
     {startIcon}
     {text && <span> {text} </span> } {innerButton ? 
     (
      <a
        href={fileUrl}
        // target="_blank"
        rel="noopener noreferrer"
        className="inner-button"
        onClick={(e) => {
          e.stopPropagation();
          if (!fileUrl) {
            e.preventDefault();
          }
        }}
      >
        {innerButtonText}
      </a>
    )
     : ""}
        {endIcon}
      </div>
    </ButtonWrapper>
  )
};

export default Index;
